export const PreviewTuningConstant = {
    UPDATE_SELECTED_POINT: "UPDATE_SELECTED_POINT",
    UPDATE_PIXEL_VALUES: "UPDATE_PIXEL_VALUES",
    UPDATE_POSITION_VALUES: "UPDATE_POSITION_VALUES",
    UPDATE_SLOTS_CROPPING_MODE: "UPDATE_SLOTS_CROPPING_MODE",
    UPDATE_SELECTED_SLOT: "UPDATE_SELECTED_SLOT",
    UPDATE_SLOT_CROP_POSITION_VALUES: "UPDATE_SLOT_CROP_POSITION_VALUES"
}

